import React from "react";
import ChipSelect from "../../../components/chipSelect";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import NewReleasesOutlinedIcon from "@mui/icons-material/NewReleasesOutlined";
import FieldLabel from "../../../components/label";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";
import {
  Autocomplete,
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Select,
  TextField,
  Stack,
  Typography,
  Button,
} from "@mui/material";

function PersonDetailsForm({
  classes: { accordianSection, contentScroller, formGroup },
  errorMessage,
  form,
  handleAccordionChange,
  handleChange,
  handleChangeChipSelect,
  handleCheckboxChange,
  isFormSubmitted,
  occupations,
  options,
  orderDetails = null,
  panErrorMessage = "",
  isPanVerifiedError = false,
  section,
  selectedOccupationOption,
  setSelectedOccupationOption,
  validateInputLength,
  verifyPancardDetails,
}) {
  const buildIncomeTaxProofOptions = (list) => {
    list.map((item) => {
      item.disabled =
        form.annual_income >= 250000 && item.value === "Form 60" ? true : false;
    });

    return list;
  };

  return (
    <>
      <Box
        className={accordianSection}
        onClick={() => handleAccordionChange("personal", section.personal)}
      >
        <Stack
          direction="row"
          gap={1}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          {!(
            form.education &&
            form.father_name &&
            selectedOccupationOption?.code &&
            form.organisation_name &&
            form.annual_income &&
            ((form.income_tax_proof === "PAN" && form.verify_pan_number) ||
              form.income_tax_proof === "Form 60")
          ) && <NewReleasesOutlinedIcon />}
          {form.education &&
            form.father_name &&
            selectedOccupationOption?.code &&
            form.organisation_name &&
            form.annual_income &&
            ((form.income_tax_proof === "PAN" && form.verify_pan_number) ||
              form.income_tax_proof === "Form 60") && (
              <CheckCircleOutlineIcon sx={{ color: "green" }} />
            )}
          <Typography variant="subtitle2">Personal Details</Typography>
        </Stack>
        <Box>
          {!section.personal && <ExpandMoreIcon fontSize="medium" />}
          {section.personal && <ExpandLessIcon fontSize="medium" />}
        </Box>
      </Box>

      {section.personal && (
        <Box p={1} mt={0} sx={{ height: "340px" }} className={contentScroller}>
          <Box className={formGroup}>
            <FieldLabel label={"Smoker*"} />
            <ChipSelect
              compact={false}
              fontWeight={"regular"}
              fieldname={"smoker"}
              handleChange={handleChangeChipSelect}
              options={options.smoker}
              selectedItem={form?.smoker}
              isMinWidth={true}
            />
          </Box>

          <Box className={formGroup}>
            <FieldLabel label={"Alcohol*"} />
            <ChipSelect
              compact={false}
              fontWeight={"regular"}
              fieldname={"alcohol"}
              handleChange={handleChangeChipSelect}
              options={options.alcohol}
              selectedItem={form?.alcohol}
              isMinWidth={true}
            />
          </Box>

          <Box className={formGroup}>
            <FieldLabel label={"Sector*"} />
            <ChipSelect
              compact={false}
              fontWeight={"regular"}
              fieldname={"sector"}
              handleChange={handleChangeChipSelect}
              options={options.sector}
              selectedItem={form?.sector}
              isMinWidth={true}
            />
          </Box>

          <Box className={formGroup}>
            <FieldLabel label={"Marital Status*"} />
            <Box display="flex">
              <ChipSelect
                compact={false}
                fontWeight={"regular"}
                fieldname={"marital_status"}
                handleChange={handleChangeChipSelect}
                options={options.maritalStatus}
                selectedItem={form?.marital_status}
                isMinWidth={true}
              />
            </Box>
          </Box>

          {1 === 2 && (
            <Box className={formGroup}>
              <FieldLabel label={"Education"} />
              <Box display="flex" fullWidth>
                <ChipSelect
                  compact={false}
                  fontWeight={"regular"}
                  fieldname={"education"}
                  handleChangeChipSelect={handleChangeChipSelect}
                  options={options.education}
                  selectedItem={form?.education}
                  disabled={form?.productConfig?.freeze_education}
                />
              </Box>
            </Box>
          )}

          <Box className={formGroup}>
            <FormControl variant="outlined" fullWidth>
              <Box justifyContent="flex-start" display="flex" textAlign="left">
                <FieldLabel label={"Education*"} />
              </Box>
              <Box
                justifyContent="flex-start"
                display="flex"
                textAlign="left"
                fullWidth
              >
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={form?.education}
                  onChange={handleChange}
                  name="education"
                  fullWidth
                  disabled={form?.productConfig?.freeze_education}
                >
                  {options.education.map((option) => {
                    return (
                      <MenuItem
                        key={`education-${option.value}`}
                        value={option.value}
                      >
                        <Typography variant="caption">
                          {option.title}
                        </Typography>
                      </MenuItem>
                    );
                  })}
                </Select>
              </Box>
            </FormControl>
          </Box>

          <Box className={formGroup}>
            <FieldLabel label={"Father Name*"} />
            <TextField
              id="standard-basic"
              variant="outlined"
              value={form.father_name}
              name="father_name"
              onChange={handleChange}
              autoComplete="off"
              helperText={errorMessage.father_name}
              fullWidth
              disabled={
                form?.productConfig?.freeze_father_name &&
                orderDetails?.fatherName
              }
            />
          </Box>

          <Box className={formGroup}>
            <FieldLabel label={"Occupation Type*"} />
            <ChipSelect
              compact={false}
              fontWeight={"regular"}
              fieldname={"occupation_type"}
              handleChange={handleChangeChipSelect}
              options={
                form?.productConfig?.occupation_type
                  ? form?.productConfig?.occupation_type
                  : options.occupationType
              }
              selectedItem={form?.occupation_type}
              disabled={form?.productConfig?.freeze_occupation_type}
            />
          </Box>

          <Box className={formGroup}>
            <FieldLabel label={"Occupation*"} />
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={occupations}
              filterOptions={(options, { inputValue }) => {
                const seen = new Set();
                return options.filter((option) => {
                  const label = option.label.toLowerCase();
                  const startsWith = label.startsWith(inputValue.toLowerCase());
                  const isUnique = !seen.has(label);
                  if (startsWith && isUnique) {
                    seen.add(label);
                    return true;
                  }
                  return false;
                });
              }}
              value={selectedOccupationOption}
              onChange={(event, newValue) => {
                setSelectedOccupationOption(newValue);
              }}
              fullWidth
              disabled={form.occupation_type === "Housewife"}
              renderInput={(params) => <TextField {...params} label="" />}
              sx={{
                "& + .MuiAutocomplete-popper .MuiAutocomplete-option": {
                  backgroundColor: "#F6F6F6",
                  fontWeight: "400 !important",
                  display: "flex",
                  justifyContent: "flex-start",
                  textAlign: "left",
                  margin: "2px 0px",
                },
              }}
            />
          </Box>

          <Box className={formGroup}>
            <FieldLabel label={"Organisation Name*"} />
            <TextField
              id="standard-basic"
              variant="outlined"
              value={form.organisation_name}
              name="organisation_name"
              onChange={handleChange}
              autoComplete="off"
              helperText={errorMessage.organisation_name}
              disabled={form.occupation_type === "Housewife"}
              fullWidth
            />
          </Box>

          <Box className={formGroup}>
            <FieldLabel label={"Annual Income*"} />
            <TextField
              id="standard-basic"
              variant="outlined"
              value={form.annual_income}
              name="annual_income"
              onChange={handleChange}
              onInput={validateInputLength}
              autoComplete="off"
              helperText={errorMessage.annual_income}
              fullWidth
              disabled={form?.productConfig?.freeze_annual_income}
            />
          </Box>

          {form.annual_income && !errorMessage.annual_income && (
            <>
              <Box className={formGroup}>
                <FieldLabel label={"Income Tax Proof*"} />
                <ChipSelect
                  compact={false}
                  fontWeight={"regular"}
                  fieldname={"income_tax_proof"}
                  handleChange={handleChangeChipSelect}
                  options={buildIncomeTaxProofOptions(options.incomeTaxProof)}
                  selectedItem={form?.income_tax_proof}
                  isMinWidth={true}
                  disabled={orderDetails?.is_pan_verified}
                />
              </Box>

              {form.income_tax_proof === "PAN" && (
                <>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Box className={formGroup} pb={0}>
                        <FieldLabel label={"PAN Number"} />
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid container spacing={1}>
                    <Grid item xs={7}>
                      <TextField
                        id="standard-basic"
                        variant="outlined"
                        value={form.pan_number}
                        name="pan_number"
                        onChange={handleChange}
                        onInput={validateInputLength}
                        autoComplete="off"
                        helperText={errorMessage.pan_number}
                        disabled={form.verify_pan_number}
                        fullWidth
                        inputProps={{ style: { textTransform: "uppercase" } }}
                      />
                    </Grid>
                    <Grid item xs={5}>
                      <Box
                        mt={0.5}
                        display={"flex"}
                        justifyContent={"flex-end"}
                        alignItems={"end"}
                        fullWidth
                      >
                        {form.verify_pan_number ? (
                          <Button
                            type="button"
                            variant="contained"
                            size="small"
                            color="success"
                          >
                            Verified
                          </Button>
                        ) : (
                          <Button
                            type="button"
                            variant="contained"
                            size="small"
                            color="secondary"
                            onClick={verifyPancardDetails}
                            {...((!form.pan_number ||
                              errorMessage.pan_number ||
                              isFormSubmitted ||
                              !form.declaration) && {
                              disabled: true,
                            })}
                          >
                            Verify
                          </Button>
                        )}
                      </Box>
                    </Grid>
                  </Grid>

                  {form.pan_number && isPanVerifiedError && (
                    <Box mb={1} sx={{ color: "red", textAlign: "left" }}>
                      <Typography variant="caption" className="error-message">
                        {panErrorMessage}
                      </Typography>
                    </Box>
                  )}

                  <Box mb={1} sx={{ textAlign: "left" }}>
                    <FormControlLabel
                      control={
                        <Box style={{ alignSelf: "start" }}>
                          <Checkbox
                            checked={form.declaration}
                            onChange={handleCheckboxChange}
                            name={"declaration"}
                            color="primary"
                            disabled={
                              form.verify_pan_number ||
                              orderDetails?.is_pan_verified
                            }
                          />
                        </Box>
                      }
                      label={
                        <Box mt={1}>
                          <Typography variant="caption">
                            <small>
                              I hereby confirm that the name fetched from PAN
                              card and from Aadhaar card are of the same person.
                            </small>
                          </Typography>
                        </Box>
                      }
                    />
                  </Box>

                  {/* <Box
                    className={formGroup}
                    display={"flex"}
                    justifyContent={"flex-end"}
                    alignItems={"end"}
                    fullWidth
                  >
                    {form.verify_pan_number ? (
                      <Button
                        type="button"
                        variant="contained"
                        size="small"
                        color="success"
                      >
                        Verified
                      </Button>
                    ) : (
                      <Button
                        type="button"
                        variant="contained"
                        size="small"
                        color="secondary"
                        onClick={verifyPancardDetails}
                        {...((!form.pan_number ||
                          errorMessage.pan_number ||
                          isFormSubmitted ||
                          !form.declaration) && {
                          disabled: true,
                        })}
                      >
                        Verify
                      </Button>
                    )}
                  </Box> */}
                </>
              )}
            </>
          )}
        </Box>
      )}
    </>
  );
}

export default withStyles(useStyles, { withTheme: true })(PersonDetailsForm);
